import styled from "styled-components";

const AuthWrapper = styled.main`
  min-height: 100vh;
  width: 100%;
`;

export default AuthWrapper;
